// Footer.js

import React from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import languageMap from './languageMap';

function Footer() {
  const selectedLanguage = languageMap.config.selectedLanguage;

  return (
      <footer className="footer">

        <img src="icons/green_text_logo.png" alt="" className="brand-logo" />

        <div className="socials">
          <a aria-label="facebook"><img src="/icons/baseline-facebook.png" alt="facebook" /></a>
          <a href="https://wa.me/972542001485" aria-label="whatsapp" rel="noopener noreferrer" target="_blank"><img src="/icons/baseline-whatss.png" alt="" /></a>
          <a href="https://www.instagram.com/heyi_events" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><img src="/icons/baseline-instagram.png" alt="Instagram" /></a>
        </div>


        <div className="footer-linkss">
          <a href="/contact" aria-label="יצירת קשר">יצירת קשר</a>
          <a href="/accessibility" aria-label="הצהרת נגישות">הצהרת נגישות</a>
          <a href="/terms" aria-label="תקנון ותנאי שימוש">תקנון ותנאי שימוש</a>
          <a href="/privacy" aria-label="פרטיות">פרטיות</a>

        </div>

      </footer>
  );
}

export default Footer;
